import React, { useRef, useEffect } from "react";
import { GeoJSON } from "react-leaflet";
import L from "leaflet"; // Glöm inte denna import!

// Helper for shallow array equality (avoid setState loop)
function shallowArrayEqual(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

// Definiera din defaultIcon EN gång i filen
const defaultIcon = L.icon({
  iconUrl: "/marker-icon.png",
  iconRetinaUrl: "/marker-icon-2x.png",
  shadowUrl: "/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export default function GeoJsonWithLayers({
  data,
  style,
  highlightedSurfaceIds,
  onLayersReady,
  children,
  pointToLayer
}) {
  const layersRef = useRef([]);
  const lastSentLayersRef = useRef([]);

  // Clear ref before render
  layersRef.current = [];

  useEffect(() => {
    // Only call onLayersReady if layers have really changed
    if (
      typeof onLayersReady === "function" &&
      !shallowArrayEqual(layersRef.current, lastSentLayersRef.current)
    ) {
      onLayersReady(layersRef.current);
      lastSentLayersRef.current = layersRef.current.slice();
    }
    // Only depend on 'data' and 'onLayersReady'
  }, [data, onLayersReady]);

  function onEachFeature(feature, layer) {
    layersRef.current.push(layer);
  }

  // Här sätter vi standardvärde om prop ej skickas in
  const effectivePointToLayer =
    pointToLayer ||
    ((feature, latlng) => L.marker(latlng, { icon: defaultIcon }));

  return (
    <GeoJSON
      data={data}
      style={f => style(f, highlightedSurfaceIds)}
      onEachFeature={onEachFeature}
      pointToLayer={effectivePointToLayer}
    >
      {children}
    </GeoJSON>
  );
}